/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  getSprite
} from '../../utils'

const sldsColours = [
  'light',
  'error',
  'warning',
  'default',
  'success',
  'inverse',
  // 'inherit',
  'event',
  'casenote',
  'sms_inbound',
  'sms_outbound',
  'email_inbound',
  'email_outbound',
  'cash_loan',
  'retail_loan',
  'consolidation_loan',
  'shortterm_investment',
  'longterm_investment',
  'funeral_cover'
]

const getStyle = (useColourClass, colour, rotateDegrees, rotateTransitionDuration, width, height) => {
  let style = {}

  if (!useColourClass) {
    style.fill = colour
  }
  if (rotateDegrees) {
    style.transform = `rotate(${rotateDegrees}deg)`
  }
  if (rotateTransitionDuration) {
    style.transition = `transform ${rotateTransitionDuration}s`
  }
  if (width) {
    style.width = width
  }
  if (height) {
    style.height = height
  }

  return style
}

export const SvgIcon = ({ className, variant, symbol, size, colour, backgroundColour, buttonIcon, bare, rotateDegrees, rotateTransitionDuration, onClick, title, style, iconWidth, iconHeight }) => {
  let sprite = getSprite(variant)
  let href = `${sprite}#${symbol}`
  let variantSymbolClass = bare === false && variant === 'standard'
    ? `slds-icon-${variant}-${symbol.replace('_','-')}`
    : null
  let iconClass = buttonIcon ? 'slds-button__icon' : 'slds-icon'
  let iconInputClass = 'slds-input__icon slds-input__icon_right'
  let sizeClass = size ? ` slds-icon_${size}` : ''
  let useColourClass = sldsColours.indexOf(colour) > -1
  let colourClass = useColourClass ? ` slds-icon-text-${colour}` : ''
  let styles = { ...{ backgroundColor: backgroundColour }, ...style }

  return (
    <span
      className={`slds-icon_container ${iconInputClass} ${className ? className : ''} ${onClick ? 'clickable' : ''}`}
      style={styles}
      title={title}
      onClick={onClick}>
      <svg
        className={`${iconClass}${sizeClass}${colourClass} ${variantSymbolClass}`}  // temporarily removed ${variantSymbolClass}
        aria-hidden={true}
        style={getStyle(useColourClass, colour, rotateDegrees, rotateTransitionDuration, iconWidth, iconHeight)}>
        <use href={href} />
      </svg>
    </span>
  )
}

SvgIcon.defaultProps = {
  colour: 'default',
  backgroundColour: 'transparent',
  bare: true
}

SvgIcon.propTypes = {
  variant: PropTypes.oneOf([
    'action',
    'custom',
    'doctype',
    'standard',
    'utility',
    'picsaos'
  ]).isRequired,
  symbol: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xx-small', 'x-small', 'small', 'medium', 'large', 'x-large']),
  colour: PropTypes.oneOfType([
    PropTypes.oneOf(sldsColours),
    PropTypes.any  // if not one of 'sldsColours', any colour string or hexadecimal can be specified
  ]),
  backgroundColour: PropTypes.string,
  buttonIcon: PropTypes.bool,
  bare: PropTypes.bool,
  rotateDegrees: PropTypes.number,
  onClick: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/svg-icon/index.js